import 'client-only';

import { type Brand } from '@/consts/brands';
import { type TreatmentCategory } from '@/consts/treatmentCategories';
import { post, type HttpError } from '@/utils/http/client';
import { urls } from '@/utils/urls';

import { type FlowType } from './consts/flowType';

const saveSurvey = async (
  brand: Brand,
  provider: string,
  surveyId: number,
  data: any,
) => post(urls[brand].api.funnels.survey.store(provider, surveyId), data);

export type CompleteSignupError = HttpError<{
  message?: string;
  errors: {
    signup?: string[];
  };
}>;

const completeSignup = async (
  brand: Brand,
  flowType: FlowType,
  treatmentCategory: TreatmentCategory,
): Promise<void> =>
  post(urls[brand].api.funnels.signup.complete(treatmentCategory, flowType));

const completeMedicalHistoryUpdate = async (brand: Brand) => {
  return await post(urls[brand].api.completeMedicalHistoryUpdate);
};

export const FunnelService = {
  saveSurvey,
  completeSignup,
  completeMedicalHistoryUpdate,
};
